import { createRadioOptionsHook } from "../hooks/create-radio-options-hook.js";
import { PlaybackRateRadioGroupCore } from "@videojs/core";
import { selectPlaybackRate } from "@videojs/core/dom";
import { useCallback } from "react";
//#region src/ui/playback-rate/use-playback-rate-options.ts
const usePlaybackRateRadioOptions = createRadioOptionsHook({
	name: "usePlaybackRateOptions",
	feature: "playbackRate",
	selector: selectPlaybackRate,
	createCore: () => new PlaybackRateRadioGroupCore()
});
/**
* Create playback rate menu options from the player playback rate state. Returns `null` when the playback rate feature
* is not configured.
*
* @param props - Optional `label`, `formatRate`, and `disabled` overrides.
*/
function usePlaybackRateOptions(props) {
	const result = usePlaybackRateRadioOptions(props);
	const setRate = useCallback((rate) => result?.setValue(String(rate)), [result?.setValue]);
	if (!result) return null;
	return {
		...result,
		rate: result.state.rate,
		setRate
	};
}
//#endregion
export { usePlaybackRateOptions };

//# sourceMappingURL=use-playback-rate-options.js.map